(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-article-body"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pe-article-toc')) {
    class PeArticleToc extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.links = Array.from(this.querySelectorAll('.pe-article-body__toc-link'));
        this.mobileQuery = window.matchMedia('(max-width: 989px)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.syncOpen = () => {
          if (this.details) this.details.open = !this.mobileQuery.matches;
        };
        this.syncOpen();
        this.mobileQuery.addEventListener('change', this.syncOpen);

        if (this.details) {
          this.details.querySelector('summary').addEventListener('click', (event) => {
            if (!this.mobileQuery.matches) event.preventDefault();
          });
        }

        this.links.forEach((link) => {
          link.addEventListener('click', (event) => {
            const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: this.reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
            history.replaceState(null, '', link.hash);
            this.setActive(link.hash.slice(1));
            if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          });
        });

        this.headings = this.links
          .map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
          .filter(Boolean);
        if (!this.headings.length || !('IntersectionObserver' in window)) return;

        this.visible = new Set();
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.visible.add(entry.target);
              else this.visible.delete(entry.target);
            });
            this.updateActive();
          },
          { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
        );
        this.headings.forEach((heading) => this.observer.observe(heading));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.syncOpen);
      }

      updateActive() {
        if (this.visible.size) {
          const first = this.headings.find((heading) => this.visible.has(heading));
          if (first) this.setActive(first.id);
          return;
        }
        // Nothing in the band: keep the last heading that sits above the band.
        const band = window.innerHeight * 0.15;
        let current = null;
        this.headings.forEach((heading) => {
          if (heading.getBoundingClientRect().top < band) current = heading;
        });
        this.setActive(current ? current.id : null);
      }

      setActive(id) {
        this.links.forEach((link) => {
          const active = id !== null && link.hash.slice(1) === id;
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('pe-article-toc', PeArticleToc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-article-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pe-article-actions')) {
    const STORAGE_KEY = 'pe-bookmarked-articles';

    const readBookmarks = () => {
      try {
        const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(value) ? value : [];
      } catch (error) {
        return [];
      }
    };

    const writeBookmarks = (list) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        return true;
      } catch (error) {
        return false;
      }
    };

    class PeArticleActions extends HTMLElement {
      connectedCallback() {
        this.bookmarkButton = this.querySelector('[data-action="bookmark"]');
        this.shareButton = this.querySelector('[data-action="share"]');
        this.toast = this.querySelector('.pe-article-header__toast');

        if (this.bookmarkButton) {
          this.syncBookmark();
          this.bookmarkButton.addEventListener('click', () => this.toggleBookmark());
        }
        if (this.shareButton) {
          this.shareButton.addEventListener('click', () => this.share());
        }
      }

      get isBookmarked() {
        return readBookmarks().includes(this.dataset.handle);
      }

      syncBookmark() {
        const saved = this.isBookmarked;
        this.bookmarkButton.setAttribute('aria-pressed', String(saved));
        this.bookmarkButton.setAttribute('aria-label', saved ? 'Remove saved article' : 'Save article');
      }

      toggleBookmark() {
        const list = readBookmarks();
        const handle = this.dataset.handle;
        const index = list.indexOf(handle);
        if (index === -1) {
          list.push(handle);
        } else {
          list.splice(index, 1);
        }
        if (writeBookmarks(list)) {
          this.syncBookmark();
          this.notify(index === -1 ? 'Article saved' : 'Article removed from saved');
        }
      }

      async share() {
        const data = { title: this.dataset.title, url: this.dataset.url || window.location.href };
        if (navigator.share) {
          try {
            await navigator.share(data);
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') return;
          }
        }
        try {
          await navigator.clipboard.writeText(data.url);
          this.notify('Link copied');
        } catch (error) {
          window.prompt('Copy this link', data.url);
        }
      }

      notify(message) {
        if (!this.toast) return;
        this.toast.textContent = message;
        this.toast.classList.add('is-visible');
        clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => {
          this.toast.classList.remove('is-visible');
        }, 2200);
      }
    }

    customElements.define('pe-article-actions', PeArticleActions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pe-faq-tabs')) {
    customElements.define(
      'pe-faq-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('.pe-faq__cat'));
          if (!this.tabs.length) return;
          this.addEventListener('click', (event) => {
            const tab = event.target.closest('.pe-faq__cat');
            if (tab) this.select(tab);
          });
          this.addEventListener('keydown', (event) => {
            const tab = event.target.closest('.pe-faq__cat');
            if (!tab) return;
            const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
            if (!keys.includes(event.key)) return;
            event.preventDefault();
            const i = this.tabs.indexOf(tab);
            let next = i;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            this.select(this.tabs[next]);
            this.tabs[next].focus();
          });
        }

        select(tab) {
          const category = tab.dataset.category;
          this.tabs.forEach((t) => {
            const active = t === tab;
            t.setAttribute('aria-selected', String(active));
            t.tabIndex = active ? 0 : -1;
          });
          const panel = this.querySelector('.pe-faq__list');
          if (panel) panel.setAttribute('aria-labelledby', tab.id);
          let first = true;
          this.querySelectorAll('.pe-faq__item').forEach((item) => {
            const show = item.dataset.category === category;
            item.hidden = !show;
            if (show) {
              item.open = first && this.dataset.openFirst !== 'false';
              first = false;
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-recipe-featured"] && !Shopify.designMode) return;
  try {
    
  /*
   * Client-side category filter for page-based recipes.
   * Pills: [data-pe-recipe-filters] [data-pe-recipe-filter="<category-handle>"] ("" = all).
   * Cards: [data-pe-recipe-list] > li > [data-pe-recipe][data-category="|hot-coffee|quick-recipes|"].
   * While a category is active the featured bento ([data-pe-recipe-bento]) is hidden and
   * [data-pe-recipe-empty] shows when nothing matches.
   */
  (() => {
    if (window.PeRecipeFilter) return;

    const cardOf = (item) => item.querySelector('[data-pe-recipe]') || item;
    const matches = (item, key) => !key || (cardOf(item).dataset.category || '').includes('|' + key + '|');
    const items = () => Array.from(document.querySelectorAll('[data-pe-recipe-list] > *'));

    const apply = (key, announce) => {
      const value = key || '';
      document.querySelectorAll('[data-pe-recipe-filters] [data-pe-recipe-filter]').forEach((pill) => {
        const active = (pill.dataset.peRecipeFilter || '') === value;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      let shown = 0;
      items().forEach((item) => {
        const visible = matches(item, value);
        item.hidden = !visible;
        if (visible) shown += 1;
      });
      document.querySelectorAll('[data-pe-recipe-bento]').forEach((bento) => {
        bento.hidden = value !== '';
      });
      document.querySelectorAll('[data-pe-recipe-empty]').forEach((empty) => {
        empty.hidden = shown > 0;
      });
      if (announce) {
        const live = document.querySelector('[data-pe-recipe-filters]')?.closest('[data-pe-recipe-root]')?.querySelector('[data-pe-live]');
        if (live) live.textContent = shown + (shown === 1 ? ' recipe' : ' recipes') + ' shown';
      }
    };

    const hideEmptyPills = (root = document) => {
      const list = items();
      root.querySelectorAll('[data-pe-recipe-filters][data-hide-empty] [data-pe-recipe-filter]').forEach((pill) => {
        const key = pill.dataset.peRecipeFilter || '';
        if (!key) return;
        const li = pill.closest('li');
        if (li) li.hidden = !list.some((item) => matches(item, key));
      });
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-pe-recipe-filter]') : null;
      if (!target) return;
      event.preventDefault();
      apply(target.dataset.peRecipeFilter || '', true);
      if (!target.closest('[data-pe-recipe-filters]')) {
        const toolbar = document.querySelector('[data-pe-recipe-filters]');
        toolbar?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        toolbar?.querySelector('[data-pe-recipe-filter=""]')?.focus({ preventScroll: true });
      }
    });

    const init = () => {
      if (!document.querySelector('[data-pe-recipe-filters]')) return;
      hideEmptyPills();
      const active = document.querySelector('[data-pe-recipe-filters] [data-pe-recipe-filter].is-active');
      apply(active ? active.dataset.peRecipeFilter || '' : '', false);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);

    window.PeRecipeFilter = { apply };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pe-reviews-list')) {
    customElements.define(
      'pe-reviews-list',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.addEventListener('click', (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (tab) return this.select(tab);
            const helpful = event.target.closest('[data-pe-helpful]');
            if (helpful) helpful.setAttribute('aria-pressed', String(helpful.getAttribute('aria-pressed') !== 'true'));
          });
          this.addEventListener('keydown', (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            event.preventDefault();
            const next = this.tabs[(this.tabs.indexOf(tab) + 1) % this.tabs.length];
            this.select(next);
            next.focus();
          });
          const sort = this.querySelector('[data-pe-sort]');
          sort?.addEventListener('change', () => this.sort(sort.value));
        }

        select(tab) {
          this.tabs.forEach((t) => {
            const active = t === tab;
            t.setAttribute('aria-selected', String(active));
            t.tabIndex = active ? 0 : -1;
            const panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          });
          const sort = this.querySelector('.pe-rv__sort');
          if (sort) sort.style.visibility = tab === this.tabs[0] ? '' : 'hidden';
        }

        sort(mode) {
          const list = this.querySelector('[data-pe-reviews]');
          if (!list) return;
          const items = Array.from(list.querySelectorAll('.pe-rv__review'));
          items.sort((a, b) => {
            const ra = Number(a.dataset.rating) || 0;
            const rb = Number(b.dataset.rating) || 0;
            if (mode === 'highest') return rb - ra || a.dataset.order - b.dataset.order;
            if (mode === 'lowest') return ra - rb || a.dataset.order - b.dataset.order;
            return a.dataset.order - b.dataset.order;
          });
          items.forEach((item) => list.appendChild(item));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
